import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { StyledCompanyLogo, StyledMessage } from "./styles";

const CompanyMessage: React.FC<{
    companyName?: string;
    companyIcon?: string;
}> = ({ companyName, companyIcon }) => (
    <StyledMessage
        variant="company"
        data-automation="company-message"
    >
        {translate("si.pages.ai_agent.form.start_message")}
        <StyledCompanyLogo src={companyIcon} />
        <Text
            fontVariant="chip1TopRow"
            color={colorsPalettes.carbon[500]}
        >
            {companyName}
        </Text>
    </StyledMessage>
);

export default CompanyMessage;
